export interface ModalParam {
  id: string;
  subId?: string;
}

const SEP = ":";
const PARAM = "modal";

export function encodeModalParam(m: ModalParam): string {
  return m.subId ? `${m.id}${SEP}${m.subId}` : m.id;
}

export function decodeModalParam(value: string | null): ModalParam | null {
  if (!value) return null;
  if (value.startsWith(SEP)) return null;
  const [id, subId, ...rest] = value.split(SEP);
  if (!id) return null;
  if (rest.length > 0) return null;
  return subId ? { id, subId } : { id };
}

function parseUrl(url: string): { path: string; search: URLSearchParams } {
  const [path, query = ""] = url.split("?", 2);
  return { path: path ?? "", search: new URLSearchParams(query) };
}

function rebuild(path: string, search: URLSearchParams): string {
  const s = search.toString();
  return s ? `${path}?${s}` : path;
}

export function withModal(url: string, m: ModalParam): string {
  const { path, search } = parseUrl(url);
  search.set(PARAM, encodeModalParam(m));
  return rebuild(path, search);
}

export function withoutModal(url: string): string {
  const { path, search } = parseUrl(url);
  search.delete(PARAM);
  return rebuild(path, search);
}

export const MODAL_QUERY_PARAM = PARAM;
